import { render, staticRenderFns } from "./ActionRevisarReparacion.vue?vue&type=template&id=15618b44&lang=pug"
import script from "./ActionRevisarReparacion.vue?vue&type=script&lang=js"
export * from "./ActionRevisarReparacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports